import axios from 'axios'

export default {
    getGptResponse(messageHistory, context) {
        return axios.post(`/unauthenticated/medgpt/medical-question`, { messageHistory, context })
    },
}
